/* eslint-disable */
import {Filtro} from "../models/filtro/filtro";


export const CaixaSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['descricao']
    filtro.addOrder('descricao', 'asc')
  return filtro
}

export const  getCaixaSCH = (campo, valor, condicao)=>{
  var filtro = new Filtro()
  filtro.perPage = 1
  filtro.filters.addFilter(campo,valor,condicao)
  filtro.fields = ['*']
  return filtro
}


export const EventoCaixaSCH = (perPage)=> {
    var filtro = new Filtro()
    filtro.perPage = perPage
    filtro.fields = ['descricao']
    filtro.addOrder('descricao', 'asc')
  return filtro
}
